import React from "react";
import { Wrapper, One, Two, Three, Four, ButtonWrapper } from "./styled";
import Button from "../Button";

function Instructions({ onNext }) {
  return (
    <Wrapper>
      <One>Ваша задача: лишить плагиатора ученой степени</One>
      <Two n={2}>
        Найдите среди научных руководителей наиболее злостного диссеродела
      </Two>
      <Two n={4}>Выберите диссертацию для проверки</Two>
      <Two n={5}>
        За 2 минуты найдите как можно больше отличий между работой плагиатора и
        оригиналом
      </Two>
      <Four>
        За действия вы получаете очки. Чем больше очков вы наберете, тем больше
        шансов лишить плагиатора ученой степени
      </Four>
      <Three>
        Если плагиатор будет вам мешать, просто не обращайте на него внимания
      </Three>
      <ButtonWrapper>
        <Button onClick={() => onNext()}>Понятно</Button>
      </ButtonWrapper>
    </Wrapper>
  );
}

export default Instructions;
